import React from "react";
import {Route, Routes} from "react-router";
import {allRoutes} from "./allRoutes";

function IndexRoute() {
    return (
        <Routes>
            {allRoutes.map((route, index) => (
                <Route
                    path={route.path}
                    element={<route.component/>}
                    key={index}
                />
            ))}
        </Routes>
    )
}

export default IndexRoute